import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import axios from 'axios'
import 'font-awesome/css/font-awesome.min.css'
import '../theme/index.css'
import ElementUI from 'element-ui'
Vue.use(ElementUI)
// import 'default-passive-events'
import VideoPlayer from 'vue-video-player'
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
import globalFun from '@/utils/globalFun'
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)


require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import { getToken, removeToken } from '@/utils/auth'
Vue.prototype.$axios = axios

Vue.use(VideoPlayer)
Vue.config.productionTip = false

// 添加globalFun
Vue.prototype.$globalFun = globalFun
Vue.prototype.$fieldFormatter = (value) => {
  return value.replace(/ /g, '')
}
import '@/styles/index.scss'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

axios.interceptors.request.use(function(config) {
  const token = getToken()
  if (token) {
    config.headers['Authorization'] = token
  }
  return config
})
const whiteList = [
  '/login',
  '/register',
  '/apply'
]
router.beforeEach((to, from, next) => {
  if (getToken()) {
    if (whiteList.includes(to.path) || to.path === '/') {
      next('/notes/standard')
    } else {
      next()
    }
  } else {
    if (!whiteList.includes(to.path)) {
      next('/login')
    } else {
      next()
    }
  }

  // if (to.path == '/login') {
  //   // localStorage.removeItem('user')
  //   // removeToken()
  //   if (getToken()) {
  //     next({
  //       path: '/home'
  //     })
  //   }
  // }
  // next()
  // if (!getToken() && to.path != '/login' && to.path != '/register' && to.path != '/apply') {
  //   next({
  //     path: '/login'
  //   })
  // } else {
  //   next()
  // }
})
import {
  Message
} from 'element-ui'
Vue.prototype.$message.success = function(msg) {
  return Message({
    message: msg,
    duration: 1500,
    type: 'success'
  })
}
Vue.prototype.$message.error = function(msg) {
  return Message({
    message: msg,
    duration: 1500,
    type: 'error'
  })
}
// Date.prototype.Format = function(fmt) {
//   var o = {
//     'M+': this.getMonth() + 1, // 月份
//     'd+': this.getDate(), // 日
//     'H+': this.getHours(), // 小时
//     'm+': this.getMinutes(), // 分
//     's+': this.getSeconds(), // 秒
//     'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
//     'S': this.getMilliseconds() // 毫秒
//   }
//   if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
//   for (var k in o) { if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
//   return fmt
// }
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
